/** 平台余额/交易金额对用户展示口径（底层可为 USDC / dUSD） */
export const PLATFORM_CURRENCY_LABEL = 'USD';

/** 展示用币种标签：usdc / dusd / u → USD；USDT 保持原样 */
export function formatDisplayCurrencyLabel(currency) {
  const cur = String(currency ?? '')
    .trim()
    .toUpperCase();
  if (cur === 'USDC' || cur === 'DUSD' || cur === 'U') return PLATFORM_CURRENCY_LABEL;
  if (cur === 'USDT') return 'USDT';
  return cur || PLATFORM_CURRENCY_LABEL;
}

/** 平台余额展示：数值 + USD（如 0.13 USD） */
export function formatPlatformU(value, digits = 2) {
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  const amount = n.toLocaleString('en-US', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
  return `${amount} ${PLATFORM_CURRENCY_LABEL}`;
}

/**
 * 充值/提现余额展示：$1.23（显示原数值，不做 <$0.01 dust 折叠）
 * （列表右侧、弹窗头栏「余额」；转账金额本身仍用 formatPlatformU）
 */
export function formatPlatformBalanceUsd(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return '$0.00';
  return `$${n.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

/** 从钱包详情接口响应读取 available */
export function readWalletAvailable(data) {
  const available = Number(data?.available);
  return Number.isFinite(available) ? available : 0;
}

/** 从 RC BalanceDTO 读取余额（balance 为 string） */
export function readRcBalanceAmount(data) {
  const raw = data?.balance ?? data?.available ?? data?.total;
  const num = Number(raw);
  return Number.isFinite(num) ? num : 0;
}

/** 从 RC BalanceDetailDTO 读取可用余额（GET /rc/balances） */
export function readRcBalanceDetailAmount(data) {
  const raw = data?.availableBalance ?? data?.balance ?? data?.usdValue;
  const num = Number(raw);
  return Number.isFinite(num) ? num : 0;
}
